var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item?.assignments?.employee?.email)?_c('div',[_vm._v(" "+_vm._s(_vm.item?.assignments?.employee?.email)+" ")]):_c('div',[_vm._v(" "+_vm._s(_vm.item?.email)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }